import { CompetencyLevel } from "./types";

export const prettifyCompetency = (competency: string) => {
    const lowerCase = competency.replaceAll('_', ' ').toLowerCase();
    const capitalised = lowerCase[0].toUpperCase() + lowerCase.slice(1);
    return capitalised;
}

export const Colors = {
    red: 'red',
    orange: 'orange',
    blue: 'blue',
    green: 'green',
};

const isColor = (color: string): color is keyof typeof Colors => {
    return Object.keys(Colors).includes(color);
}

export const safeGetColor = (
    colorName: string,
) => {
    if (isColor(colorName)) {
        return Colors[colorName];
    }
    return undefined;
};

export const getCompetencyColor = (competency_level?: CompetencyLevel) => {
    if (!competency_level) return safeGetColor('fallback');
    return typeof competency_level === 'string'
        ? safeGetColor('fallback')
        : safeGetColor(competency_level.color);
};

export const getCompetencyName = (competency_level: CompetencyLevel) => {
    return typeof competency_level === 'string'
        ? competency_level
        : competency_level.name;
};
